const PAGE_LAST_READ_KEY = 'lastReadNotificationId';
const GLOBAL_LAST_READ_KEY = 'globalLastReadNotificationId';

export const getLastReadNotificationId = (): number | null => {
  const value = localStorage.getItem(PAGE_LAST_READ_KEY);
  if (!value) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

export const setLastReadNotificationId = (id: number) => {
  localStorage.setItem(PAGE_LAST_READ_KEY, String(id));
};

export const getGlobalLastReadNotificationId = (): number | null => {
  const value = localStorage.getItem(GLOBAL_LAST_READ_KEY);
  if (!value) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

export const setGlobalLastReadNotificationId = (id: number) => {
  // Глобальная отметка только увеличивается
  const current = getGlobalLastReadNotificationId();
  const next = current == null ? id : Math.max(current, id);
  localStorage.setItem(GLOBAL_LAST_READ_KEY, String(next));
};
